import Equipment from "./../equipment";
import Ingredients from "./../ingredients";
import { recipeTypes } from "../recipeTypes";

const Recipe = {
  type: recipeTypes.bread,

  title: "Shortbread",

  subtitle: "butter biscuits",

  background: require("../../media/shortbread.jpg"),

  details: ["Buttery, crumbly and simple.", "Makes 16-20 biscuits."],

  equipment: [
    Equipment.Mixing_bowl("large"),
    Equipment.Spatula("soft, to mix"),
    Equipment.Rolling_pin(),
    Equipment.Baking_tray(),
    Equipment.Baking_paper(),
    Equipment.Oven_gloves(),
    Equipment.Baking_rack(),
  ],

  optional_equipment: [Equipment.Food_processor(), Equipment.Knife("or cookie cutter")],

  ingredients: [
    Ingredients.Butter(125, "softened"),
    Ingredients.Sugar("55g CASTER", "plus extra for sprinkling"),
    Ingredients.Flour("180g PLAIN"),
  ],

  optional_ingredients: [],

  prep: [
    "Preheat oven to 190°C / 170°C FAN",
    "Cream BUTTER and SUGAR",
    "Mix in FLOUR",
    "Bring dough together gently",
    "Roll to 1cm thick",
    "Cut rounds or fingers",
    "Sprinkle with SUGAR",
    "Chill for 20 min",
  ],

  prep_time: 30,

  method: ["Bake 15-20 min until pale golden", "Cool on a baking rack"],

  cook_time: 30,
};

export default Recipe;
